import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { IonContent } from "@ionic/angular";
import { ConfigService } from "src/app/services/config/config.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { CashierBase } from "../../cashier-base/cashier-base";

@Component({
    selector: 'app-deposit-neosurf-action',
    templateUrl: './deposit-neosurf-action.component.html',
    styleUrls: ['./deposit-neosurf.component.scss'],
})

export class DepositNeosurfActionComponent extends CashierBase implements OnInit {
    @ViewChild(IonContent, { static: false }) content: IonContent;
    @Input() neosurfData;

    protected iframe_url: string;
    protected customer: any;

    constructor(
        readonly config: ConfigService,
        readonly userSessionService: UserSessionService
    ) {
        super();
    }

    ngOnInit(): void {
        this.userSessionService.getCustomer().subscribe(customer => {
            this.customer = customer;
        });
        this.createNeosurf(this.neosurfData);
    }

    private createNeosurf(data?: any): void {
        const params: any = {
            amount: data.amount,
            currency: data.currencyCode,
            customer_id: this.customer?.customerId,
            merchantTransactionId: data.merchantTransactionId,
            skindId: null
        };

        const webserviceUrl: string = this.config.getConfig().WEBSERVICES_URL
        const endpoint: string = '/external/neosurf-post';
        const queryString = Object.keys(params)
            .map((key) => key + "=" + params[key])
            .join("&");

        this.iframe_url = `${webserviceUrl}${endpoint}?${queryString}`;
    }
}